export const translations = {
    en: {
        page: { key: 'EN' },
        adhoc: {
            welcome: {
                title: 'Welcome',
                charging_without_registration: 'Charging without registration',
                charging_price: '[green]€0.59 per kWh[/green]',
                fill_in_charger_code: 'Fill in charger code to continue',
            },
            footer: {
                app: {
                    charging_with_us_more_often: '[bold]Charging with us more often?[/bold]',
                    use_the_fastned_app: 'Use the Fastned app',
                },
            },
            shared: {
                buttons: {
                    continue_with_credit_card: 'Continue to credit card details',
                    continue_with_ideal: 'Continue to iDEAL',
                    continue: 'Continue',
                    select_payment_method: 'Select payment method',
                    retry_and_select_payment_method: 'Retry payment',
                    get_support: 'Call Support',
                    request_receipt: 'Request receipt',
                    call_support: 'Call Support',
                    search: 'Search',
                    back: 'Back',
                },
                payment_types: { ideal: 'iDEAL', cc: 'Credit Card' },
                payment_methods: { ideal: 'iDEAL', credit_card: 'Credit card' },
                charger: 'Charger',
                and: 'and',
                select_your_language: 'Select your language',
            },
            choose_payment_method: {
                title: 'Select your payment method',
                agreement_text: 'If you agree now, you give permission to Fastned to start charging and to charge the charging costs incurred. Our payment process is carried out by payment processor Adyen, more information can be found here. Our privacy statement also applies and can be found here.',
            },
            choose_connector: { title: 'Connect the cable to your vehicle and select the connector type' },
            payment_info: {
                title: 'How we handle your payment 🤝',
                ideal: {
                    bullets: {
                        b1: 'We charge [green][bold]€0.59 per kWh[/green][/bold]',
                        b2: "Because we don't know how much kWh you will charge, we ask you to pay [green][bold]€35 in advance[/green][/bold]",
                        b3: 'We will [green][bold]refund the difference[/green][/bold] between the €35 and the amount you have charged for',
                    },
                    refunds: {
                        line1: 'Refunds are usually processed within 2 business hours',
                        line2: 'Example 10 kWh session:',
                        bullets: {
                            b1: 'Advance: €35.00',
                            b2: 'Cost: 10 kWh x €0.59 = €5.90',
                            b3: 'Refund: €35.00 - €5.90 = €29.10',
                        },
                    },
                },
                credit_card: {
                    bullets: {
                        b1: 'We charge [green][bold]€0.59 per kWh[/green][/bold]',
                        b2: "Because we don't know how much kWh you will charge, we will [green][bold]reserve an amount of €35[/green][/bold] on your credit card",
                        b3: 'Only the energy actually consumed, will be charged on your credit card',
                    },
                },
            },
            payment_cancelled: {
                title: 'It looks like you cancelled your payment',
                worried_about: 'Worried about the €35?',
                worried_about_info: 'No worries! As soon as we know how much you have charged, we will refund the amount of the €35 that you did not use. ',
                how_we_handle_your_payment: {
                    title: 'How we handle your payment 🤝',
                    b1: 'We charge [green][bold]€0.59 per kWh[/green][/bold]',
                    b2: "Because we don't know how much kWh you will charge, we ask you to pay [green][bold]€35 in advance[/green][/bold]",
                    b3: 'We will [green][bold]refund the difference[/green][/bold] between the €35 and the amount you have charged for',
                },
            },
            payment_failed: {
                title: 'It looks like your payment failed',
                info: 'Did something go wrong? Please try again. You could try using a different payment method.',
            },
            payment_success: {
                title: 'Payment successful!',
                info: "We'll start charging your electric spaceship on [blue]charger 4[/blue] with [blue]CCS[/blue] ",
                use_charger_screen: '👉 Use the charger screen to stop your charging session',
                about_your_charge_speed: 'About your charge speed',
                session_details: {
                    title: 'Charging session details',
                    date: 'Date',
                    start_time: 'Start time',
                    station: 'Station',
                    charger_number: 'Charger number',
                    charger_code: 'Charger code',
                    connector_type: 'Connector type',
                    payment_method: 'Payment method',
                    payment_reference: 'Payment reference',
                },
                get_support: 'Help',
            },
            support: {
                give_us_a_call: 'Check the support portal above or give us a call',
                title: 'Help',
                info: 'Need support? Check our support portal or give us a call. We are there for you 24/7',
                url: 'https://support.fastned.nl/hc/en-gb/search?utf8=%E2%9C%93&query=',
                request_invoice_email: {
                    title: 'Receipt request ad hoc charging session',
                    body: 'Hi Fastned,\n%0D%0D\nI hereby request a VAT receipt for my charging session.\n%0D%0D\nMy session details:\n%0D%0D\nDate: {{date}}\n%0D%0D\nStart time: {{time}}\n%0D%0D\nStation: {{station}}\n%0D%0D\nCharger number: {{charger_number}}\n%0D%0D\nCharger code: {{charger_code}}\n%0D%0D\nConnector type: {{connector_type}}\n%0D%0D\nPayment method: {{payment_method}}\n%0D%0D\nPayment reference: #{{payment_reference}}',
                    recipient: 'support@fastned.co.uk',
                },
                about_charge_speed: {
                    url: 'https://support.fastned.nl/hc/en-gb/articles/205694717-What-determines-the-charge-speed',
                },
            },
            start_failed: {
                title: 'It looks we could not start your charging session',
                info: 'We cancelled the payment. Please check if the carger cable is connected properly and retry.',
            },
            invalid_charger_code: {
                title: 'It looks like the charger code is invalid',
                info: 'We could not find a charger with the code you entered. Please try again.',
                retry: 'Retry',
            },
        },
    },
    nl: {
        page: { key: 'NL' },
        adhoc: {
            welcome: {
                title: 'Welkom',
                charging_without_registration: 'Laden zonder registreren',
                charging_price: '[green]€0,59 per kWh[/green]',
                fill_in_charger_code: 'Vul de ladercode in om verder te gaan',
            },
            footer: {
                app: {
                    charging_with_us_more_often: '[bold]Laad je vaker bij ons?[/bold]',
                    use_the_fastned_app: 'Gebruik de Fastned-app',
                },
            },
            shared: {
                buttons: {
                    continue_with_credit_card: 'Ga door naar credit gegevens',
                    continue_with_ideal: 'Ga door naar iDEAL',
                    continue: 'Ga door',
                    select_payment_method: 'Selecteer betaalmethode',
                    retry_and_select_payment_method: 'Probeer betaling opnieuw',
                    get_support: 'Bel Support',
                    request_receipt: 'Bonnetje vragen',
                    call_support: 'Call Support',
                    search: 'Zoek',
                    back: 'Terug',
                },
                payment_types: { ideal: 'iDEAL', cc: 'Creditcard' },
                payment_methods: { ideal: 'iDEAL', credit_card: 'Creditcard' },
                charger: 'Lader',
                and: 'en',
                select_your_language: 'Select your language',
            },
            choose_payment_method: {
                title: 'Selecteer je betaalmethode',
                agreement_text: 'Als je nu akkoord gaat geef je toestemming aan Fastned om het laden te starten en om de gemaakte laadkosten in rekening te brengen. Ons betalingsproces wordt uitgevoerd door betalingsverwerker Adyen, meer informatie vind je hier. Ook is ons privacy statement van toepassing en vind je hier.',
            },
            choose_connector: { title: 'Steek de stekker in je voertuig en selecteer het stekkertype' },
            payment_info: {
                title: 'Hoe we je betaling afhandelen 🤝',
                ideal: {
                    bullets: {
                        b1: 'Je betaalt [green][bold]€0,59 per kWh[/green][/bold]',
                        b2: 'Omdat we niet weten hoeveel kWh je gaat laden, vragen we je [green][bold]€35 vooruit te betalen[/green][/bold]',
                        b3: 'We [green][bold]betalen het verschil terug[/green][/bold] tussen de €35 en het bedrag waarvoor je geladen hebt',
                    },
                    refunds: {
                        line1: 'Terugbetalingen worden doorgaans verwerkt binnen 2 kantooruren',
                        line2: 'Voorbeeldsessie van 10 kWh:',
                        bullets: {
                            b1: 'Vooruitbetaling: €35,00',
                            b2: 'Kosten: 10 kWh x €0,59 = €5,90',
                            b3: 'Terugbetaling: €35,00 - €5,90 = €29,10',
                        },
                    },
                },
                credit_card: {
                    bullets: {
                        b1: 'Je betaalt [green][bold]€0,59 per kWh[/green][/bold]',
                        b2: 'Omdat we niet weten hoeveel kWh je gaat laden, [green][bold]reserveren we €35[/green][/bold] op je creditcard',
                        b3: 'Alleen de werkelijk verbruikte energie wordt van je creditcard afgeschreven',
                    },
                },
            },
            payment_cancelled: {
                title: 'Het lijkt erop dat je de betaling hebt geannuleerd',
                worried_about: 'Bezorgd over de €35?',
                worried_about_info: 'Geen zorgen! Zodra we weten hoeveel je in geladen hebt, betalen we het gedeelte van de €35 dat je niet hebt gebruikt terug.',
                how_we_handle_your_payment: {
                    title: 'Hoe we je betaling afhandelen 🤝',
                    b1: 'Je betaalt [green][bold]€0,59 per kWh[/green][/bold]',
                    b2: 'Omdat we niet weten hoeveel kWh je gaat laden, vragen we je [green][bold]€35 vooruit te betalen[/green][/bold]',
                    b3: 'We [green][bold]betalen het verschil terug[/green][/bold] tussen de €35 en het bedrag waarvoor je geladen hebt',
                },
            },
            payment_failed: {
                title: 'Het lijkt erop dat je betaling is mislukt',
                info: 'Ging er iets mis? Probeer het opnieuw. Je kunt het ook met een andere betaalmethode proberen.',
            },
            payment_success: {
                title: 'Betaling gelukt!',
                info: 'We starten de laadsessie van jouw elektrische ruimteschip op [blue]lader 4[/blue] met [blue]CCS[/blue]',
                use_charger_screen: '👉 Gebruik het laderscherm om de laadsessie te beëindigen',
                about_your_charge_speed: 'Over jouw laadsnelheid',
                session_details: {
                    title: 'Details laadsessie',
                    date: 'Datum',
                    start_time: 'Starttijd',
                    station: 'Station',
                    charger_number: 'Ladernummer',
                    charger_code: 'Ladercode',
                    connector_type: 'Stekkertype',
                    payment_method: 'Betaalmethode',
                    payment_reference: 'Betalingskenmerk',
                },
                get_support: 'Hulp',
            },
            support: {
                give_us_a_call: 'Check the support portal above or give us a call',
                title: 'Hulp',
                info: 'Need support? Check our support portal or give us a call. We are there for you 24/7',
                url: 'https://support.fastned.nl/hc/nl/search?utf8=%E2%9C%93&query=',
                request_invoice_email: {
                    title: 'Aanvraag bon ad-hoc laadsessie',
                    body: 'Dag Fastned,\n%0D%0D\nHierbij vraag ik een btw-bon aan van mijn laadsessie.\n%0D%0D\nDe details van mijn laadsessie:\n%0D%0D\nDate: {{date}}\n%0D%0D\nStart time: {{time}}\n%0D%0D\nStation: {{station}}\n%0D%0D\nCharger number: {{charger_number}}\n%0D%0D\nCharger code: {{charger_code}}\n%0D%0D\nConnector type: {{connector_type}}\n%0D%0D\nPayment method: {{payment_method}}\n%0D%0D\nPayment reference: #{{payment_reference}}',
                    recipient: 'support@fastned.nl',
                },
                about_charge_speed: {
                    url: 'https://support.fastned.nl/hc/nl/articles/205694717-Waar-hangt-de-laadsnelheid-vanaf-',
                },
            },
            start_failed: {
                title: 'Het lijkt erop dat we je laadsessie niet kunnen starten',
                info: 'We hebben de betaling geannuleerd. Controleer of de stekker correct is aangesloten en probeer het opnieuw.',
            },
            invalid_charger_code: {
                title: 'Het lijkt erop dat de ladercode ongeldig is',
                info: 'We konden geen lader vinden met de code die je hebt ingevoerd. Probeer het opnieuw.',
                retry: 'Probeer opnieuw',
            },
        },
    },
    de: {
        page: { key: 'DE' },
        adhoc: {
            welcome: { title: '', charging_without_registration: '', charging_price: '', fill_in_charger_code: '' },
            footer: { app: { charging_with_us_more_often: '', use_the_fastned_app: '' } },
            shared: {
                buttons: {
                    continue_with_credit_card: '',
                    continue_with_ideal: '',
                    continue: '',
                    select_payment_method: '',
                    retry_and_select_payment_method: '',
                    get_support: '',
                    request_receipt: '',
                    call_support: '',
                    search: '',
                    back: '',
                },
                payment_types: { ideal: '', cc: '' },
                payment_methods: { ideal: '', credit_card: '' },
                charger: '',
                and: '',
                select_your_language: '',
            },
            choose_payment_method: { title: '', agreement_text: '' },
            choose_connector: { title: '' },
            payment_info: {
                title: '',
                ideal: {
                    bullets: { b1: '', b2: '', b3: '' },
                    refunds: { line1: '', line2: '', bullets: { b1: '', b2: '', b3: '' } },
                },
                credit_card: { bullets: { b1: '', b2: '', b3: '' } },
            },
            payment_cancelled: {
                title: '',
                worried_about: '',
                worried_about_info: '',
                how_we_handle_your_payment: { title: '', b1: '', b2: '', b3: '' },
            },
            payment_failed: { title: '', info: '' },
            payment_success: {
                title: '',
                info: '',
                use_charger_screen: '',
                about_your_charge_speed: '',
                session_details: {
                    title: '',
                    date: '',
                    start_time: '',
                    station: '',
                    charger_number: '',
                    charger_code: '',
                    connector_type: '',
                    payment_method: '',
                    payment_reference: '',
                },
                get_support: '',
            },
            support: {
                give_us_a_call: '',
                title: '',
                info: '',
                url: '',
                request_invoice_email: { title: '', body: '', recipient: '' },
                about_charge_speed: { url: '' },
            },
            start_failed: { title: '', info: '' },
            invalid_charger_code: { title: '', info: '', retry: '' },
        },
    },
    fr: {
        page: { key: 'FR' },
        adhoc: {
            welcome: { title: '', charging_without_registration: '', charging_price: '', fill_in_charger_code: '' },
            footer: { app: { charging_with_us_more_often: '', use_the_fastned_app: '' } },
            shared: {
                buttons: {
                    continue_with_credit_card: '',
                    continue_with_ideal: '',
                    continue: '',
                    select_payment_method: '',
                    retry_and_select_payment_method: '',
                    get_support: '',
                    request_receipt: '',
                    call_support: '',
                    search: '',
                    back: '',
                },
                payment_types: { ideal: '', cc: '' },
                payment_methods: { ideal: '', credit_card: '' },
                charger: '',
                and: '',
                select_your_language: '',
            },
            choose_payment_method: { title: '', agreement_text: '' },
            choose_connector: { title: '' },
            payment_info: {
                title: '',
                ideal: {
                    bullets: { b1: '', b2: '', b3: '' },
                    refunds: { line1: '', line2: '', bullets: { b1: '', b2: '', b3: '' } },
                },
                credit_card: { bullets: { b1: '', b2: '', b3: '' } },
            },
            payment_cancelled: {
                title: '',
                worried_about: '',
                worried_about_info: '',
                how_we_handle_your_payment: { title: '', b1: '', b2: '', b3: '' },
            },
            payment_failed: { title: '', info: '' },
            payment_success: {
                title: '',
                info: '',
                use_charger_screen: '',
                about_your_charge_speed: '',
                session_details: {
                    title: '',
                    date: '',
                    start_time: '',
                    station: '',
                    charger_number: '',
                    charger_code: '',
                    connector_type: '',
                    payment_method: '',
                    payment_reference: '',
                },
                get_support: '',
            },
            support: {
                give_us_a_call: '',
                title: '',
                info: '',
                url: '',
                request_invoice_email: { title: '', body: '', recipient: '' },
                about_charge_speed: { url: '' },
            },
            start_failed: { title: '', info: '' },
            invalid_charger_code: { title: '', info: '', retry: '' },
        },
    },
};
